module.exports = __webpack_public_path__ + "static/media/gk-coconut-solo.985096d5.png";